import { stringify } from 'query-string';
import { httpRequest } from '@v4/http/request';
import { getApiUrl } from '@v4/config';
import { getStringifiedQueryParamsFromBrowser, stringifyUrl } from '@v4/common/utils/url';

export const baseUrl = `${getApiUrl()}/dkwp/v3/offers`;
export const baseUrlMultipleOffers = `${getApiUrl()}/dkwp/v3/offers-multiple`;

/**
 * Gets offers
 *
 * @param {object} params query string
 * @returns {Promise<object>}
 */
export const getOffers = (params) => httpRequest({ url: `${baseUrl}?${stringify(params)}` });

/**
 * Gets model offers
 *
 * @param {string} make make name
 * @param {string} model model name
 * @returns {Promise<object>}
 */
export const getModelOffers = (make, model) =>
    httpRequest({
        url: `${baseUrl}/${make}/${model}${getStringifiedQueryParamsFromBrowser()}`,
        timeout: 2500,
        cache: false,
    });

/**
 * Gets privacy flags by projectId
 *
 * @param {string} projectId Project identifier
 * @returns {Promise<object>}
 */
export const getModelPrivacy = (projectId) =>
    httpRequest({
        url: stringifyUrl({
            url: `${getApiUrl()}/dkwp/v3/project/extra_privacies`,
            // eslint-disable-next-line camelcase
            query: { project_id: projectId },
        }),
        cache: false,
    });
